import { useState } from "react";
import "@/App.css";
import { ChevronDown, Check, Users, Gift, Shield, GraduationCap, TrendingUp, Sparkles, MessageCircle, Truck, Award, Star, FileText } from "lucide-react";

function App() {
  const [openFAQ, setOpenFAQ] = useState(null);

  const toggleFAQ = (index) => {
    setOpenFAQ(openFAQ === index ? null : index);
  };

  const MESSENGER_URL = "https://m.me/100077562768980";
  const CONTACT_FORM_URL = "https://forms.gle/eRC6NxnGa8GZkSbv5";

  const faqs = [
    {
      question: "What exactly do I get with the ₱2,150 AI Network Package?",
      answer: "You receive an incredible value stack! This includes: Up to ₱2,994 worth of premium products (your choice of 2 Gummy bottles), ₱50,000 worth of accident insurance coverage for one year, at least ₱50,000 worth of paid expert-led trainings on digital marketing and ecommerce/dropshipping, plus a 30% lifetime discount on all future purchases and the opportunity to earn both actively and passively through our marketing plan. All of this for just ₱2,150!"
    },
    {
      question: "How does the 30% lifetime discount work?",
      answer: "Once you join with the ₱2,150 package, you'll receive a permanent 30% discount on all AI Connect products for life. This means every future purchase you make will be 30% off the regular price, giving you incredible savings as you continue your journey with us."
    },
    {
      question: "Can I earn money with AI Connect?",
      answer: "Absolutely! Our marketing plan allows you to earn both actively (through direct sales and building your network) and passively (through team commissions and bonuses). Many of our 30,000+ members are creating substantial income streams by sharing these amazing products and business opportunity with others."
    },
    {
      question: "Is the training really worth ₱50,000?",
      answer: "Yes! Our expert-led training programs cover comprehensive digital marketing strategies, ecommerce fundamentals, dropshipping mastery, social media marketing, and AI-powered business tools. These are the same trainings that cost thousands of pesos when purchased separately. You get lifetime access to all materials and updates."
    },
    {
      question: "How long does the accident insurance coverage last?",
      answer: "Your ₱50,000 accident insurance coverage is valid for one full year from the date of your enrollment. This provides you with peace of mind and protection while you build your business."
    },
    {
      question: "How do I get started?",
      answer: "Getting started is simple! Just click any 'Join Now' or 'Message Us' button to chat with us directly on Messenger, or fill out our contact form. Our team will guide you through the enrollment process and help you choose your 2 preferred Gummy bottles."
    }
  ];

  const benefits = [
    {
      icon: <Gift className="w-8 h-8" />,
      title: "Premium Products",
      description: "Choose 2 Gummy bottles from our premium product line - up to ₱2,994 value"
    },
    {
      icon: <Shield className="w-8 h-8" />,
      title: "Insurance Coverage",
      description: "₱50,000 accident insurance protection for one full year"
    },
    {
      icon: <GraduationCap className="w-8 h-8" />,
      title: "Expert Training",
      description: "At least ₱50,000 worth of expert-led digital marketing & ecommerce training"
    },
    {
      icon: <TrendingUp className="w-8 h-8" />,
      title: "Lifetime Discount",
      description: "30% off all future purchases forever"
    },
    {
      icon: <Sparkles className="w-8 h-8" />,
      title: "Dual Income Streams",
      description: "Earn actively through sales and passively through team commissions"
    },
    {
      icon: <Truck className="w-8 h-8" />,
      title: "Free Nationwide Shipping",
      description: "Enjoy free shipping on all your orders across the Philippines"
    }
  ];

  const testimonials = [
    { name: "Mark Jestin Manalo", role: "Businessman", location: "San Leonardo, Nueva Ecija", amount: "₱1,074,114" },
    { name: "Angel Serrano", role: "Educator", location: "Biñan City, Laguna", amount: "₱1,000,000" },
    { name: "Katrina Kallyle Dela Cruz", role: "Housewife", location: "Philippines", amount: "₱392,076" },
    { name: "Ferdinand Ginez", role: "Driver", location: "Philippines", amount: "₱19,485" },
    { name: "Jerico Yatco", role: "Operations", location: "Biñan City, Laguna", amount: "₱9,521" },
    { name: "Randy Dolorito", role: "Marketer", location: "Philippines", amount: "₱4,275" }
  ];

  const products = [
    { name: "Barley Gummies", benefit: "Detox & Immunity", price: "₱997" },
    { name: "Berberine Gummies", benefit: "Blood Sugar Support", price: "₱997" },
    { name: "Apple Cider Vinegar Gummies", benefit: "Weight Management", price: "₱997" },
    { name: "Collagen Glutathione Gummies", benefit: "Radiant Skin", price: "₱1,497" }
  ];

  const industries = [
    { title: "E-COMMERCE", description: "Online retail & sales" },
    { title: "FRANCHISING", description: "Business ownership" },
    { title: "BRANDING", description: "Personal & product brand" },
    { title: "DISTRIBUTION", description: "Nationwide network" }
  ];

  return (
    <div className="min-h-screen bg-white">
      {/* Navigation Bar */}
      <nav className="sticky top-0 z-50 bg-white/95 backdrop-blur-md border-b-2 border-pink-500 shadow-sm">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            <div className="flex items-center gap-2">
              <div className="text-2xl font-bold">
                <span className="text-pink-500">Ai</span>
                <span className="text-black ml-1">Connect</span>
              </div>
            </div>
            <div className="hidden md:flex items-center gap-6">
              <a href="#benefits" className="text-black hover:text-pink-500 font-semibold transition-colors">Benefits</a>
              <a href="#products" className="text-black hover:text-pink-500 font-semibold transition-colors">Products</a>
              <a href="#testimonials" className="text-black hover:text-pink-500 font-semibold transition-colors">Success Stories</a>
              <a href="#pricing" className="text-black hover:text-pink-500 font-semibold transition-colors">Pricing</a>
              <a
                href={MESSENGER_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="px-4 py-2 bg-gradient-to-r from-pink-500 to-pink-600 text-white font-bold rounded-full text-sm hover:shadow-lg hover:shadow-pink-500/50 transition-all"
                data-testid="nav-messenger-btn"
              >
                <MessageCircle className="w-4 h-4 inline mr-1" />
                Chat Now
              </a>
            </div>
          </div>
        </div>
      </nav>

      {/* Hero Section with Video */}
      <section className="relative bg-gradient-to-br from-black via-gray-900 to-black text-white">
        <div className="absolute inset-0 bg-gradient-to-r from-pink-500/10 via-transparent to-cyan-500/10"></div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 lg:py-16">
          {/* Official AI Connect Logo with Industries */}
          <div className="max-w-2xl mx-auto mb-8">
            <img
              src="/images/ai-connect-logo.jpg"
              alt="AI Connect - Birth of the Interconnected Industry Era"
              className="w-full h-auto rounded-2xl shadow-2xl border-2 border-pink-500"
              loading="eager"
              width="1024"
              height="583"
              data-testid="official-logo"
            />
          </div>

          <div className="text-center mb-8">
            <p className="text-xl lg:text-2xl text-gray-300 mb-3">Transform Your Future with AI-Powered Success</p>
            <div className="flex items-center justify-center gap-2 text-cyan-400 font-semibold text-lg">
              <Users className="w-5 h-5" />
              <span>30,000+ Members and Counting</span>
            </div>
          </div>

          {/* Founder's Video */}
          <div className="max-w-4xl mx-auto mb-8">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl border-4 border-pink-500">
              <div className="aspect-video bg-black">
                <iframe
                  src="https://player.vimeo.com/video/1212641541?badge=0&autopause=0&player_id=0&app_id=58479"
                  className="w-full h-full"
                  frameBorder="0"
                  allow="autoplay; fullscreen; picture-in-picture; clipboard-write"
                  allowFullScreen
                  title="AI Connect Founder's Message"
                  loading="eager"
                  data-testid="founder-video-iframe"
                ></iframe>
              </div>
            </div>
            <p className="text-center mt-4 text-gray-300 text-lg font-semibold">
              🎥 Watch our founder's message about the incredible AI Connect opportunity
            </p>
          </div>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <a
              href="#pricing"
              className="px-8 py-4 bg-gradient-to-r from-pink-500 to-pink-600 hover:from-pink-600 hover:to-pink-700 text-white font-bold rounded-full text-lg shadow-lg hover:shadow-pink-500/50 transition-all duration-300 transform hover:scale-105"
              data-testid="hero-join-btn"
            >
              Join Now for ₱2,150
            </a>
            <a
              href={MESSENGER_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="px-8 py-4 bg-cyan-500 hover:bg-cyan-600 text-black font-bold rounded-full text-lg shadow-lg hover:shadow-cyan-500/50 transition-all duration-300 transform hover:scale-105 flex items-center gap-2"
              data-testid="hero-messenger-btn"
            >
              <MessageCircle className="w-5 h-5" />
              Message Us
            </a>
          </div>
        </div>
      </section>

      {/* Industries Section */}
      <section className="py-12 lg:py-16 bg-gradient-to-r from-pink-50 via-white to-cyan-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-10">
            <h2 className="text-3xl lg:text-4xl font-bold text-black mb-3">
              One <span className="text-pink-500">Collaboration System</span>
            </h2>
            <p className="text-lg text-gray-600">Four Industries. Infinite Opportunities.</p>
          </div>
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 lg:gap-6">
            {industries.map((industry, index) => (
              <div
                key={index}
                className="bg-white rounded-2xl p-6 text-center shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 border-2 border-pink-200 hover:border-pink-500"
                data-testid={`industry-${index}`}
              >
                <div className="w-16 h-16 mx-auto mb-4 bg-gradient-to-br from-pink-500 to-cyan-400 rounded-full flex items-center justify-center">
                  <Sparkles className="w-8 h-8 text-white" />
                </div>
                <h3 className="font-bold text-black text-lg mb-1">{industry.title}</h3>
                <p className="text-sm text-gray-600">{industry.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section id="benefits" className="py-16 lg:py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-4xl lg:text-5xl font-bold text-black mb-4">
              Why Choose <span className="text-pink-500">AI Connect</span>?
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              An incredible value stack for just ₱2,150 - The most amazing opportunity in network marketing!
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {benefits.map((benefit, index) => (
              <div
                key={index}
                className="bg-white border-2 border-gray-200 rounded-xl p-6 hover:border-pink-500 hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2"
                data-testid={`benefit-card-${index}`}
              >
                <div className="w-16 h-16 bg-gradient-to-br from-pink-500 to-cyan-400 rounded-lg flex items-center justify-center text-white mb-4">
                  {benefit.icon}
                </div>
                <h3 className="text-xl font-bold text-black mb-2">{benefit.title}</h3>
                <p className="text-gray-600">{benefit.description}</p>
              </div>
            ))}
          </div>

          {/* Trust Badges */}
          <div className="mt-12 flex flex-wrap justify-center items-center gap-8">
            <div className="flex items-center gap-2 text-gray-700">
              <Award className="w-6 h-6 text-cyan-500" />
              <span className="font-semibold">FDA Approved</span>
            </div>
            <div className="flex items-center gap-2 text-gray-700">
              <Shield className="w-6 h-6 text-pink-500" />
              <span className="font-semibold">GMP Certified</span>
            </div>
            <div className="flex items-center gap-2 text-gray-700">
              <Check className="w-6 h-6 text-cyan-500" />
              <span className="font-semibold">All Natural Ingredients</span>
            </div>
            <div className="flex items-center gap-2 text-gray-700">
              <Star className="w-6 h-6 text-pink-500" />
              <span className="font-semibold">Quality You Can Trust</span>
            </div>
          </div>
        </div>
      </section>

      {/* Products Section */}
      <section id="products" className="py-16 lg:py-20 bg-gradient-to-br from-pink-50 to-cyan-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-4xl lg:text-5xl font-bold text-black mb-4">
              Premium <span className="text-pink-500">Products</span>
            </h2>
            <p className="text-xl text-gray-600">Choose your 2 favorite gummy bottles with your ₱2,150 package</p>
          </div>

          {/* Product Hero Image - Compact & Mobile Friendly */}
          <div className="max-w-md mx-auto mb-10">
            <img
              src="/images/gummies-products.jpg"
              alt="AI Connect Premium Gummies - Barley, Berberine, Apple Cider Vinegar, Collagen Glutathione"
              className="w-full h-auto rounded-2xl shadow-xl"
              loading="lazy"
              width="700"
              height="700"
              data-testid="products-hero-image"
            />
            <p className="text-center mt-3 text-gray-700 font-semibold text-base">
              💊 Love Thy Health - Premium Food Supplements
            </p>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 lg:gap-6">
            {products.map((product, index) => (
              <div
                key={index}
                className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 border-2 border-transparent hover:border-pink-500 p-5"
                data-testid={`product-card-${index}`}
              >
                <h3 className="font-bold text-black text-sm lg:text-base mb-1">{product.name}</h3>
                <p className="text-xs lg:text-sm text-gray-600 mb-3">{product.benefit}</p>
                <div className="flex items-center justify-between">
                  <span className="text-xs text-gray-500 font-semibold">SRP</span>
                  <span className="text-pink-500 font-bold text-lg">{product.price}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section id="testimonials" className="py-16 lg:py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-4xl lg:text-5xl font-bold text-black mb-4">
              Real People, <span className="text-pink-500">Real Success</span>
            </h2>
            <p className="text-xl text-gray-600">Daily encashments from our thriving community of 30,000+ members</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {testimonials.map((testimonial, index) => (
              <div
                key={index}
                className="bg-gradient-to-br from-pink-50 to-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 border-2 border-pink-200"
                data-testid={`testimonial-card-${index}`}
              >
                <div className="bg-gradient-to-r from-pink-500 to-pink-600 text-white p-4">
                  <div className="flex items-center gap-2">
                    <div className="bg-black text-white px-2 py-1 rounded text-xs font-bold">
                      <span className="text-pink-400">Ai</span>Connect
                    </div>
                    <span className="font-bold text-sm">TESTIMONIALS</span>
                  </div>
                </div>
                <div className="p-6 text-center">
                  <p className="text-pink-500 font-bold text-sm mb-1">CONGRATULATIONS!</p>
                  <p className="text-gray-600 text-xs mb-3">ON THE SUCCESSFUL DAILY ENCASHMENT</p>
                  <p className="text-3xl lg:text-4xl font-black text-black mb-2">{testimonial.amount}</p>
                  <p className="text-gray-500 text-sm mb-4">TODAY</p>
                  <div className="bg-black text-white py-2 px-4 rounded">
                    <p className="text-pink-400 font-bold">{testimonial.name}</p>
                  </div>
                  <div className="flex justify-between items-center mt-3 text-xs">
                    <span className="text-gray-600">{testimonial.role}</span>
                    <span className="bg-pink-100 text-pink-600 px-2 py-1 rounded font-semibold">{testimonial.location}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="mt-12 text-center">
            <p className="text-lg text-gray-700 font-semibold">
              💖 <span className="text-pink-500">AI Connect</span> is here to empower more Filipinos and help you achieve your financial goals!
            </p>
          </div>
        </div>
      </section>

      {/* Pricing Section */}
      <section id="pricing" className="py-16 lg:py-20 bg-gradient-to-br from-gray-50 to-gray-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-4xl lg:text-5xl font-bold text-black mb-4">
              Unbeatable <span className="text-pink-500">Value</span>
            </h2>
            <p className="text-xl text-gray-600">Your gateway to success starts here</p>
          </div>

          <div className="max-w-2xl mx-auto">
            <div className="bg-white rounded-3xl shadow-2xl overflow-hidden border-4 border-pink-500">
              <div className="bg-gradient-to-r from-pink-500 via-pink-600 to-cyan-500 text-white text-center py-8">
                <h3 className="text-3xl font-bold mb-2">AI Network Package</h3>
                <div className="flex items-center justify-center gap-4">
                  <span className="text-5xl lg:text-6xl font-bold">₱2,150</span>
                  <span className="text-sm bg-white/20 px-3 py-1 rounded-full">One-time</span>
                </div>
                <p className="mt-2 text-pink-100">Your complete starter package!</p>
              </div>

              <div className="p-6 lg:p-10">
                <div className="space-y-4 mb-8">
                  <div className="flex items-start gap-3">
                    <div className="flex-shrink-0 w-6 h-6 bg-pink-500 rounded-full flex items-center justify-center mt-1">
                      <Check className="w-4 h-4 text-white" />
                    </div>
                    <div>
                      <p className="font-semibold text-black">Premium Products (₱2,994 value)</p>
                      <p className="text-gray-600">Your choice of 2 Gummy bottles</p>
                    </div>
                  </div>

                  <div className="flex items-start gap-3">
                    <div className="flex-shrink-0 w-6 h-6 bg-cyan-500 rounded-full flex items-center justify-center mt-1">
                      <Check className="w-4 h-4 text-black" />
                    </div>
                    <div>
                      <p className="font-semibold text-black">Accident Insurance (₱50,000 value)</p>
                      <p className="text-gray-600">One year of comprehensive coverage</p>
                    </div>
                  </div>

                  <div className="flex items-start gap-3">
                    <div className="flex-shrink-0 w-6 h-6 bg-pink-500 rounded-full flex items-center justify-center mt-1">
                      <Check className="w-4 h-4 text-white" />
                    </div>
                    <div>
                      <p className="font-semibold text-black">Expert Training (₱50,000+ value)</p>
                      <p className="text-gray-600">Digital marketing & ecommerce/dropshipping mastery</p>
                    </div>
                  </div>

                  <div className="flex items-start gap-3">
                    <div className="flex-shrink-0 w-6 h-6 bg-cyan-500 rounded-full flex items-center justify-center mt-1">
                      <Check className="w-4 h-4 text-black" />
                    </div>
                    <div>
                      <p className="font-semibold text-black">30% Lifetime Discount</p>
                      <p className="text-gray-600">On all future purchases forever</p>
                    </div>
                  </div>

                  <div className="flex items-start gap-3">
                    <div className="flex-shrink-0 w-6 h-6 bg-pink-500 rounded-full flex items-center justify-center mt-1">
                      <Check className="w-4 h-4 text-white" />
                    </div>
                    <div>
                      <p className="font-semibold text-black">Active & Passive Income Opportunities</p>
                      <p className="text-gray-600">Earn through our proven marketing plan</p>
                    </div>
                  </div>

                  <div className="flex items-start gap-3">
                    <div className="flex-shrink-0 w-6 h-6 bg-cyan-500 rounded-full flex items-center justify-center mt-1">
                      <Check className="w-4 h-4 text-black" />
                    </div>
                    <div>
                      <p className="font-semibold text-black">Free Nationwide Shipping</p>
                      <p className="text-gray-600">On all your orders across the Philippines</p>
                    </div>
                  </div>
                </div>

                <div className="flex flex-col sm:flex-row gap-3">
                  <a
                    href={MESSENGER_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex-1 py-4 bg-gradient-to-r from-pink-500 to-pink-600 hover:from-pink-600 hover:to-pink-700 text-white font-bold rounded-full text-lg shadow-lg hover:shadow-pink-500/50 transition-all duration-300 transform hover:scale-105 flex items-center justify-center gap-2"
                    data-testid="pricing-messenger-btn"
                  >
                    <MessageCircle className="w-5 h-5" />
                    Chat on Messenger
                  </a>
                  <a
                    href={CONTACT_FORM_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex-1 py-4 bg-cyan-500 hover:bg-cyan-600 text-black font-bold rounded-full text-lg shadow-lg hover:shadow-cyan-500/50 transition-all duration-300 transform hover:scale-105 flex items-center justify-center gap-2"
                    data-testid="pricing-form-btn"
                  >
                    <FileText className="w-5 h-5" />
                    Sign Up Form
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="py-16 lg:py-20 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-4xl lg:text-5xl font-bold text-black mb-4">
              Frequently Asked <span className="text-pink-500">Questions</span>
            </h2>
            <p className="text-xl text-gray-600">Everything you need to know about AI Connect</p>
          </div>

          <div className="space-y-4">
            {faqs.map((faq, index) => (
              <div
                key={index}
                className="border-2 border-gray-200 rounded-xl overflow-hidden hover:border-pink-500 transition-colors duration-300"
                data-testid={`faq-item-${index}`}
              >
                <button
                  onClick={() => toggleFAQ(index)}
                  className="w-full px-6 py-5 text-left flex items-center justify-between bg-white hover:bg-gray-50 transition-colors duration-200"
                  data-testid={`faq-question-${index}`}
                >
                  <span className="font-semibold text-black text-lg pr-4">{faq.question}</span>
                  <ChevronDown
                    className={`flex-shrink-0 w-6 h-6 text-pink-500 transition-transform duration-300 ${openFAQ === index ? 'transform rotate-180' : ''}`}
                  />
                </button>
                <div
                  className={`overflow-hidden transition-all duration-300 ${openFAQ === index ? 'max-h-[500px]' : 'max-h-0'}`}
                >
                  <div className="px-6 py-5 bg-gradient-to-r from-pink-50 to-cyan-50 border-t-2 border-gray-200">
                    <p className="text-gray-700 leading-relaxed" data-testid={`faq-answer-${index}`}>{faq.answer}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Final CTA Section */}
      <section className="py-16 lg:py-20 bg-gradient-to-br from-black via-gray-900 to-black text-white relative overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-r from-pink-500/20 via-transparent to-cyan-500/20"></div>
        <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl lg:text-5xl font-bold mb-6">
            Ready to Transform Your Life?
          </h2>
          <p className="text-xl text-gray-300 mb-8 max-w-2xl mx-auto">
            Join 30,000+ successful members who are already building their future with AI Connect. Get incredible value for just ₱2,150!
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <a
              href={MESSENGER_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="px-8 py-4 bg-gradient-to-r from-pink-500 to-pink-600 hover:from-pink-600 hover:to-pink-700 text-white font-bold rounded-full text-lg shadow-lg hover:shadow-pink-500/50 transition-all duration-300 transform hover:scale-105 flex items-center gap-2"
              data-testid="final-messenger-btn"
            >
              <MessageCircle className="w-6 h-6" />
              Message Us
            </a>
            <a
              href={CONTACT_FORM_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="px-8 py-4 bg-cyan-500 hover:bg-cyan-600 text-black font-bold rounded-full text-lg shadow-lg hover:shadow-cyan-500/50 transition-all duration-300 transform hover:scale-105 flex items-center gap-2"
              data-testid="final-form-btn"
            >
              <FileText className="w-6 h-6" />
              Fill Out Form
            </a>
          </div>
          <p className="mt-8 text-sm text-gray-400">
            Don't miss this incredible opportunity!
          </p>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-black text-white py-8 border-t-4 border-pink-500">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <div className="text-3xl font-bold mb-3">
              <span className="text-pink-500">Ai</span>
              <span className="text-white ml-2">Connect</span>
            </div>
            <p className="text-gray-400 mb-2">
              Birth of the Interconnected Industry Era
            </p>
            <p className="text-gray-400 mb-6 text-sm">
              E-Commerce • Franchising • Branding • Distribution
            </p>
            <div className="flex flex-col sm:flex-row gap-3 justify-center items-center mb-6">
              <a
                href={MESSENGER_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 px-6 py-3 bg-gradient-to-r from-pink-500 to-cyan-500 text-white font-bold rounded-full hover:shadow-lg hover:shadow-pink-500/50 transition-all"
                data-testid="footer-messenger-btn"
              >
                <MessageCircle className="w-5 h-5" />
                Chat on Messenger
              </a>
              <a
                href={CONTACT_FORM_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 px-6 py-3 bg-white text-black font-bold rounded-full hover:shadow-lg transition-all"
                data-testid="footer-form-btn"
              >
                <FileText className="w-5 h-5" />
                Sign Up Form
              </a>
            </div>
            <p className="text-gray-500 text-sm">
              © 2026 AI Connect. All rights reserved. | FDA Approved • GMP Certified • Quality You Can Trust
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default App;
